import styled from '@emotion/styled'
import { palette } from '../constants'
import { Text } from '../typography'

const SIZE = 24 // px

interface ICheckmarkProps {
  checked: boolean
  disabled: boolean
  invalid: boolean
}

export const Checkmark = styled.span<ICheckmarkProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: ${SIZE - 1}px;
  width: ${SIZE - 1}px;
  background-color: ${palette.white};
  border-radius: 3px;
  border: 1px solid;
  border-color: ${({ checked, disabled, invalid }) => {
    if (invalid) return palette.poppy2
    if (disabled) return palette.chrome
    if (checked) return palette.skyBlue2
    return palette.chrome
  }};

  &:after {
    display: none;
    position: absolute;
    content: '';
    left: 7px;
    top: 3px;
    width: 5px;
    height: 11px;
    transform: rotate(45deg);
    border-style: solid;
    border-width: 0 3px 3px 0;
    border-color: ${({ disabled }) => {
      if (disabled) return palette.chrome
      return palette.white
    }};
  }
`

interface IInputProps {
  disabled: boolean
}

export const Input = styled.input<IInputProps>`
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  cursor: pointer;

  &:checked ~ ${Checkmark} {
    background: ${({ disabled }) => {
      if (disabled) return palette.white
      return palette.skyBlue2
    }};
  }

  &:checked ~ ${Checkmark}:after {
    display: block;
  }
`

interface IContainerProps {
  disabled: boolean
}

export const Container = styled(Text.withComponent('label'))<IContainerProps>`
  display: block;
  position: relative;
  cursor: pointer;
  min-height: ${SIZE}px;
  padding-left: ${SIZE + 15}px;
  color: ${({ disabled }) => {
    if (disabled) return palette.mediumGray
    return palette.almostBlack
  }};
`
